
@let contractModificationRequestTypeCode = contractModificationRequest?.dictionaryContractModificationRequestTypeCode;
<div class="request-details-container d-flex flex-column gap-4" *ngIf="dataLoaded">
    <div class="d-flex align-items-start">
        <div class="request-details-header flex-grow-1 d-flex flex-column mb-3">
            <div class="d-flex align-items-center gap-3 mb-2">
                <button class="btn link-btn btn-back">
                    <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectListHandler()"></i>
                </button>
                <div class="request-details-type fw-bold">
                    {{ contractModificationRequest?.dictionaryReimbursementTypeId ?
                    contractModificationRequest?.dictionaryReimbursementTypeName :
                    contractModificationRequest?.dictionaryContractModificationRequestTypeName }}
                </div>
            </div>

            <div>
                {{'requests.details.category.dateOfRequest' | translate}} 
                <span HJSuppress>{{contractModificationRequest?.createdOn | localizedDate}}</span>
            </div>
            <div>
                {{'requests.details.category.requestInitiatedBy' | translate}}:
                <span HJSuppress class="fw-bold">{{ contractModificationRequest?.createdByName | titlecase }}</span>
            </div>
        </div>

        <ng-container *ngIf="!isAdmin || contractModificationRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <div class="status-content">
                    <div class="status-dot" 
                        [ngClass]="contractModificationRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                                contractModificationRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress': 
                                contractModificationRequest.dictionaryRequestStatus?.code=== dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                                contractModificationRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                    </div>
                    <div class="status-value status-value-lg">{{ contractModificationRequest.dictionaryRequestStatus?.value}}</div>
                </div>
            </div>
        </ng-container>
        
        <ng-container *ngIf="isAdmin && contractModificationRequest.dictionaryRequestStatus?.code!==dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <kendo-dropdownlist HJSuppress
                    id="status-dropdownlist" 
                    class="custom-kendo-control-xl request-status-dropdown k-picker-fill-none"
                    [fillMode]="fillModeNone" 
                    [rounded]="roundedLarge"
                    [size]="sizeLarge"
                    [(ngModel)]="statusId"
                    [data]="statuses"
                    [textField]="'value'"
                    [valueField]="'id'"
                    [valuePrimitive]="true"
                    [popupSettings]="{popupClass: 'request-status-dropdown-popup data-hj-suppress', appendTo : 'component'}"
                    (ngModelChange)="changeContractModificationRequestStatus($event)"
                >
                    <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-status>
                        <div class="status-content">
                            <div class="status-dot"
                                [ngClass]="{
                                    'status-posted': status?.code === dictionaryRequestStatus.POSTED,
                                    'status-in-progress': status?.code === dictionaryRequestStatus.IN_PROGRESS,
                                    'status-resolved': status?.code === dictionaryRequestStatus.RESOLVED,
                                    'status-closed': status?.code === dictionaryRequestStatus.CLOSED,
                                    'status-default': ![dictionaryRequestStatus.POSTED, dictionaryRequestStatus.IN_PROGRESS, dictionaryRequestStatus.RESOLVED, dictionaryRequestStatus.CLOSED].includes(status?.code)
                                }"
                            ></div>
                            <div class="status-value status-value-lg">{{ status?.value }}</div>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
        </ng-container>
    </div>

    <request-detail-category-selector class="mb-3" [selectedCategory]="selectedCategory"
        (categoryChange)="categoryChangeHandler($event)">
    </request-detail-category-selector>

    @switch (selectedCategory) {
    @case (REQUEST_DETAIL_CATEGORY.INFO){
    <div class="card">
        <div class="card-body">
            <ng-container>
                <div class="detail-item-container">
                    <span class="detail-category">{{'contractModifications.wizard.preview.contractAndModificationType' |
                        translate}}</span>
                    <span class="detail-item">&bull;
                        <span class="detail-text">{{'requests.details.contract' | translate}}
                            <span HJSuppress
                                class="text-primary fw-bold">{{contractModificationRequestHeader?.contractName}}</span>
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{contractModificationRequest?.dictionaryContractModificationRequestTypeName}}
                        </span>
                    </span>
                </div>
                <div class="detail-item-container"
                    *ngIf="(contractModificationRequestTypeCode !== OTHER?.code) && 
                        (contractModificationRequestTypeCode !== FINANCING_OFFER?.code) && 
                        (contractModificationRequestTypeCode !== COMPLAINTS?.code) && 
                        (contractModificationRequestTypeCode !== CONTRACT_ASSIGNMENT?.code) &&
                        (contractModificationRequestTypeCode !== DIRECT_DEBIT?.code)">
                    <span class="detail-category">{{'contractModifications.wizard.preview.reasonOfRequest' |
                        translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{reasonOfRequest}}
                        </span>
                    </span>
                </div>

                <div class="detail-item-container"
                    *ngIf="INSTALLMENT_DEFERRAL?.code === contractModificationRequestTypeCode">
                    <span class="detail-category">{{'contractModifications.wizard.preview.defermentPeriod' |
                        translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{contractModificationRequest?.defermentPeriodStart | localizedDate:"MMMM YYYY"}} -
                            {{contractModificationRequest?.defermentPeriodEnd | localizedDate:"MMMM YYYY"}}
                        </span>
                    </span>
                </div>

                <div class="detail-item-container"
                    *ngIf="REIMBURSEMENT?.code === contractModificationRequestTypeCode">
                    <span class="detail-category">{{'contractModifications.wizard.preview.sourceOfPayment' |
                        translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{contractModificationRequest?.dictionaryPaymentSourceName}}
                        </span>
                    </span>
                </div>

                <div class="detail-item-container"
                    *ngIf="REIMBURSEMENT?.code === contractModificationRequestTypeCode">
                    <span class="detail-category">
                        {{'contractModifications.wizard.preview.amountToBeReimbursed' | translate}}
                        <span
                            *ngIf="contractModificationRequest.dictionaryReimbursementTypeCode === FULL_REIMBURSEMENT?.code">
                            {{'contractModifications.wizard.preview.additionalFees' | translate}}
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{contractModificationRequest?.reimbursedAmount | number : '1.01' }}
                            {{contractModificationRequestHeader?.currencyCode}}
                        </span>
                    </span>
                </div>

                <ng-container
                    *ngIf="
                            contractModificationRequestTypeCode === INSTALLMENT_DEFERRAL?.code ||
                            contractModificationRequest.dictionaryReimbursementTypeCode === PARTIAL_REIMBURSEMENT?.code">
                    <div class="detail-item-container">
                        <span class="detail-category">
                            <span
                                *ngIf="PARTIAL_REIMBURSEMENT?.code === contractModificationRequest.dictionaryReimbursementTypeCode; else INSTALLMENTDEFERALPREVIEW">
                                {{'contractModifications.wizard.preview.purposeOfReimbursement' | translate}}
                            </span>
                            <ng-template #INSTALLMENTDEFERALPREVIEW>
                                <span
                                    *ngIf="INSTALLMENT_DEFERRAL?.code === contractModificationRequestTypeCode">
                                    {{'contractModifications.wizard.preview.purposeOfRequest' | translate}}
                                </span>
                            </ng-template>
                        </span>

                        <span class="detail-item">&bull;
                            <span HJSuppress class="detail-text">
                                {{contractModificationRequest?.dictionaryContractModificationRequestPurposeName}}
                            </span>
                        </span>
                    </div>
                </ng-container>
                
                <ng-container 
                    *ngIf="(contractModificationRequestTypeCode === OTHER?.code) ||       
                        (contractModificationRequestTypeCode === FINANCING_OFFER?.code) ||        
                        (contractModificationRequestTypeCode === COMPLAINTS?.code) ||
                        (contractModificationRequestTypeCode === CONTRACT_ASSIGNMENT?.code)">
                    <div class="detail-item-container" 
                        *ngIf="(contractModificationRequestTypeCode === OTHER?.code)">
                        <span class="detail-category">{{'contractModifications.wizard.preview.modificationType' | translate}}</span>
                        <span class="detail-item">&bull;
                            <span HJSuppress class="detail-text">
                                {{contractModificationRequest?.otherModificationType}}
                            </span>
                        </span>
                    </div>

                    <div class="detail-item-container">
                        <span class="detail-category">{{'contractModifications.wizard.preview.description' | translate}}</span>
                        <span class="detail-item">&bull;
                            <span HJSuppress class="detail-text">
                                {{contractModificationRequest?.description}}
                            </span>
                        </span>
                    </div>
                </ng-container>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.dateOfRequest' | translate}}</span>
                    <span HJSuppress class="detail-item">&bull;
                        <span class="detail-text">{{contractModificationRequest?.createdOn | localizedDate}}</span>
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
    }
    @case (REQUEST_DETAIL_CATEGORY.DOCUMENTS) {
    <request-documents [requestId]="contractModificationRequest.contractModificationRequestId"
        [requestTypeCode]="DICTIONARY_REQUEST_TYPES.CONTRACT_MODIFICATION" [selectedCategory]="selectedCategory">
    </request-documents>
    }
    @case (REQUEST_DETAIL_CATEGORY.COMMENTS) {
    <div class="card">
        <div class="card-body">
            <request-comment [requestId]="contractModificationRequest.contractModificationRequestId"
                [requestTypeCode]="DICTIONARY_REQUEST_TYPES.CONTRACT_MODIFICATION"
                [selectedCategory]="selectedCategory">
            </request-comment>
        </div>
    </div>
    }
    }
</div>